module.exports = __webpack_public_path__ + "img/vannkraft.bd56fc74.jpg";